import { PayloadAction } from '@reduxjs/toolkit'
import { TProductFilters } from '../../../models'

const setPrice = (
  state: TProductFilters[],
  action: PayloadAction<{
    id: number
    price?: { from: number; to: number }
  }>
) => {
  const selectedFilters = state.find((item) => item.id === action.payload.id)

  if (!selectedFilters) {
    const newState = {
      id: action.payload.id,
      filters: {
        price: action.payload.price,
      },
    }
    state.push(newState)
  } else {
    selectedFilters.filters.price = action.payload.price
  }
}

export default setPrice
